<div class="content">
  <h1>we should render the whiteboards here</h1>
  <h1 *ngIf="(isGetAllLoading$ | async) === true">Get All Loading Indicator</h1>
  <div *ngFor="let whiteboard of (whiteboards$ | async)?.items" class="sp-mt-24 d-block">
    <gh-example-whiteboard-component [whiteboard]="whiteboard"></gh-example-whiteboard-component>
  </div>

  <div *ngIf="(isGetLoading$ | async) === true" class="sp-mt-48 d-block">Singular Get Loading Indicator</div>
  <div class="sp-mt-24 d-block">
    {{ (whiteboard$ | async)?.name }}
  </div>
</div>
